import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["panel", "fab", "messages"]
    static values = { open: { type: Boolean, default: false } }

    connect() {
        this.keydownHandler = (e) => {
            if (e.key === "Escape" && this.openValue) this.close()
        }
        document.addEventListener("keydown", this.keydownHandler)
    }

    disconnect() {
        document.removeEventListener("keydown", this.keydownHandler)
    }

    toggle() { this.openValue = !this.openValue }
    close() { this.openValue = false }

    openValueChanged(isOpen) {
        if (isOpen) {
            this.panelTarget.classList.remove("hidden", "closing")
            this.fabTarget.classList.add("scale-0", "opacity-0")

            const input = this.panelTarget.querySelector("textarea")
            if (input) setTimeout(() => input.focus(), 300)
        } else {
            this.panelTarget.classList.add("closing")
            this.fabTarget.classList.remove("scale-0", "opacity-0")
            setTimeout(() => {
                if (!this.openValue) this.panelTarget.classList.add("hidden")
            }, 200)
        }
    }
}
